module.exports = __webpack_public_path__ + "img/news-7.ba9c1dfb.png";